window.filters__getFilterValues = () => {
    const checkboxOrRadios = [];
    const filterValues = [];
    $.each($('#filter__table-filter-form :input').not('button'), function (index, el) {
        el = $(el);
        const name = el.attr('name');
        const type = el.attr('type');
        if (!checkboxOrRadios.includes(name) && name) {
            let val;
            let filterType;
            if (['radio', 'checkbox'].includes(type)) {
                checkboxOrRadios.push(name);
                const inp = $(`#filter__table-filter-form [name="${name}"]:checked`);
                val = inp.val();
                filterType = +inp.data('filter-type');
            } else {
                val = el.val();
                filterType = +el.data('filter-type');
            }
            filterValues.push({
                'field': name,
                'value': val || null,
                'type': filterType
            });
        }
    });

    return filterValues;
}
window.filter__setCountOfRows = async () => {
    if (typeof filter__getCountRowsCallback !== 'undefined') {
        const count = await filter__getCountRowsCallback()
        $('#filter__table-filter-form .filter-count-container').text(count);
    }
}
$(document).ready(function () {
    filter__setCountOfRows();
});

$(document).on('submit', '#filter__table-filter-form', function (e) {
    e.preventDefault();
    if (typeof filter__manageSubmitFilter !== 'undefined') {
        filter__manageSubmitFilter()
    }
    $(document).trigger('filters-submitted');
});

$(document).on('click', '#filter__table-filter-form .filter-header', function () {
    const _this = $(this);
    const container = _this.closest('.filter-container');
    container.find('.filter-body').toggleClass('show');
    _this.find('.filter-icon').toggleClass('active');
});

$(document).on('click', '#filter__table-filter-form .filter-clear-btn', function () {
    filter__changeBlocked = true;
    const form = $(this).closest('form');
    $.each(form.find(':input').not('button').not('[type="checkbox"]').not('[type="radio"]'), function (i, e) {
        const el = $(e);
        el.val('').trigger('change');
    });
    form.find('select[multiple]').val([])
    form.find('[type="checkbox"], [type="radio"]').prop('checked', false);
    form.find('[type="checkbox"][value=""], [type="radio"][value=""]').prop('checked', true);
    filter__changeBlocked = false;
    filter__setCountOfRows();
});
var filter__changeBlocked = false;
$(document).on('change', '#filter__table-filter-form :input', function () {
    if (!filter__changeBlocked) {
        filter__setCountOfRows();
    }
});

$(document).on('click', '.filter-toggle-btn', function () {
    const filterBlock = $('.filter-block');
    const contentBlock = $('.content-block');

    if (filterBlock.hasClass('d-none')) {
        filterBlock.removeClass('d-none');
        filterBlock.removeClass('col-lg-0');
        filterBlock.addClass('col-lg-3');
        contentBlock.removeClass('col-lg-12');
        contentBlock.addClass('col-lg-9');
    } else {
        filterBlock.removeClass('col-lg-3');
        filterBlock.addClass('col-lg-0');
        filterBlock.addClass('d-none');
        contentBlock.removeClass('col-lg-9');
        contentBlock.addClass('col-lg-12');
    }
});
